<mat-card>
    <mat-card-header>
        <mat-card-title id="inforReport" class="mat-card-title-custom">{{'total_contract_report.card_title' | translate}} {{'search_form.processing' | translate | lowercase}}
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="mb-3 mat-card-content-contract-sm">
        <!-- Filter -->
        <mat-accordion #accordion="matAccordion" [multi]="true">
            <mat-expansion-panel [(expanded)]="isExpanded" class="mt-3">
                <mat-expansion-panel-header>
                    <mat-panel-title class="mat-panel-title">
                        {{'report_components.filter_title' | translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <form #myForm="ngForm" class="pb-3" >
                  <div class="row">
                        <!-- Mã hợp đồng -->
                        <div class="col-lg-4 col-md-6">
                            <mat-form-field class="w-100">
                                <input type="text"
                                    (focusout)="documents.contractCode = documents.contractCode == undefined ? '' : (documents.contractCode + '').trim()"
                                    #focusInput matInput [placeholder]="'search_form.doc_code' | translate"
                                    name="contractCode" [(ngModel)]="documents.contractCode" maxlength="255"
                                    autocomplete="off">
                                <button mat-button *ngIf="documents.contractCode" type="button" matSuffix
                                    mat-icon-button aria-label="Clear" (click)="documents.contractCode=''">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>

                        <!-- Loại hợp đồng -->
                        <div class="col-lg-4 col-md-6">
                            <mat-form-field class="w-100">
                              <mat-label>{{'form.service_type' | translate}}</mat-label>
                              <mat-select #serviceTypeSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                                          (focus)="commonService.openComboBox(checkFocus, serviceTypeSelect)" id="serviceType"
                                          [disabled]="!myForm.valid" name="serviceType" [(ngModel)]="documents.serviceType">
                                <mat-option>
                                  <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                                                         [placeholderLabel]="'search_form.search' | translate"
                                                         [formControl]="serviceTypesFilterCtrl">
                                  </ngx-mat-select-search>
                                </mat-option>
                                <mat-option value="null" selected
                                            (click)="this.commonService.closeDropdownList(this.serviceTypeSelect)">
                                  {{'form.select_all' | translate}}
                                </mat-option>
                                <div class="service-type-loading" *ngIf="isServiceTypesLoading">
                                  <i class="fa fa-circle-o-notch fa-spin"></i>
                                </div>
                                <mat-option *ngFor="let serviceType of filteredServiceTypes | async" [value]="serviceType.id"
                                            (click)="this.commonService.closeDropdownList(this.serviceTypeSelect)">
                                  {{serviceType.name}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>

                          <div class="col-md-6 col-lg-4">
                            <mat-form-field class="w-100">
                                <mat-label>{{'search_form.processing_progress' | translate}}</mat-label>
                                <mat-select #statusSelect (focusout)="(checkFocus = true)" 
                                    (selectionChange)="checkFocus = false" [(ngModel)]="documents.status"
                                    (focus)="commonService.openComboBox(checkFocus, statusSelect)" id="status"
                                    name="status">
                                    <mat-option selected
                                        (click)="this.commonService.closeDropdownList(this.statusSelect)">
                                        {{'form.select_all' | translate}}</mat-option>
                                    <mat-option [value]="1"
                                        (click)="this.commonService.closeDropdownList(this.statusSelect)">
                                        {{'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.wait_setup_flow' | translate}}</mat-option>
                                    <mat-option [value]="2"
                                        (click)="this.commonService.closeDropdownList(this.statusSelect)">
                                        {{'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.processing' | translate}}</mat-option>
                                    <mat-option [value]="3"
                                        (click)="this.commonService.closeDropdownList(this.statusSelect)">
                                        {{'enterprise_contract.panel_document_view.table_signing_flow.user_status.signing' | translate}}</mat-option>
                                    <mat-option [value]="4"
                                        (click)="this.commonService.closeDropdownList(this.statusSelect)">
                                        {{'enterprise_contract.panel_document_view.table_signing_flow.user_status.initialling' | translate}}</mat-option>
                                    <mat-option [value]="5"
                                        (click)="this.commonService.closeDropdownList(this.statusSelect)">
                                        {{'enterprise_contract.panel_document_view.table_signing_flow.user_status.approving' | translate}}</mat-option>
                                    <mat-option *ngIf="entType == 2" [value]="6"
                                        (click)="this.commonService.closeDropdownList(this.statusSelect)">
                                        {{'enterprise_contract.panel_document_view.table_information_signed.enterprise_status.processing' | translate}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <!-- Tên người thực hiện  -->
                        <div class="col-lg-4 col-md-6">
                            <mat-form-field class="w-100">
                                <input type="text"
                                    (focusout)="documents.userName = documents.userName == undefined ? '' : (documents.userName + '').trim()"
                                    #focusInput matInput [placeholder]="'search_form.performerName' | translate"
                                    name="userName" [(ngModel)]="documents.userName" maxlength="255" autocomplete="off">
                                <button mat-button *ngIf="documents.userName" type="button" matSuffix mat-icon-button
                                    aria-label="Clear" (click)="documents.userName=''">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>

                        <!-- Số điện thoại -->
                        <div class="col-lg-4 col-md-6">
                            <mat-form-field class="w-100">
                                <input type="text"
                                    (focusout)="documents.phone = documents.phone == undefined ? '' : (documents.phone + '').trim()"
                                    #focusInput matInput [placeholder]="'headertable.phone' | translate" name="phone" (keypress)="allowOnlyNumbersAndSpace($event)"
                                    [(ngModel)]="documents.phone" maxlength="15" autocomplete="off">
                                <button mat-button *ngIf="documents.phone" type="button" matSuffix mat-icon-button
                                    aria-label="Clear" (click)="documents.phone=''">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>

                        <!-- Email người thực hiện  -->
                        <div class="col-lg-4 col-md-6">
                            <mat-form-field class="w-100">
                                <input type="text"
                                    (focusout)="documents.email = documents.email == undefined ? '' : (documents.email + '').trim()"
                                    #focusInput matInput [placeholder]="'search_form.performerEmail' | translate"
                                    name="email" [(ngModel)]="documents.email" maxlength="255" autocomplete="off">
                                <button mat-button *ngIf="documents.email" type="button" matSuffix mat-icon-button
                                    aria-label="Clear" (click)="documents.email=''">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>

                        <!-- Thời gian nhận (từ ngày) -->
                        <div class="col-lg-4 col-md-6">
                            <mat-form-field class="w-100">
                                <mat-label>{{ 'search_form.dateRequest' | translate }}</mat-label>
                                <input matInput [matDatepicker]="receivedAt" [max]="maxDate"
                                    #receivedAtCtrl="ngModel"
                                    (change)="this.commonService.resetDatePicker(pickerInput.value, this.ngForm.controls['receivedAt'])"
                                    name="receivedAt" #pickerInput [(ngModel)]="documents.receivedAt" maxlength="200"
                                    (focus)="createdDateErr = 'fromDate'" autocomplete="off" />
                                <mat-datepicker-toggle matSuffix [for]="receivedAt">
                                    <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                                        [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                                </mat-datepicker-toggle>
                                <mat-datepicker #receivedAt></mat-datepicker>
                                <mat-error *ngIf="receivedAtCtrl?.errors?.matDatepickerParse">
                                    {{'validation.format_of_date' | translate}}
                                </mat-error>
                                <mat-error *ngIf="receivedAtCtrl?.errors?.matDatepickerMax">
                                    {{ 'search_form.received_date_from' | translate }}
                                    {{ 'validation.from_date_smaller_than_or_equal_to_date' | translate }}
                                    {{ 'search_form.received_date_to' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Tên hợp đồng-->
                        <div class="col-lg-4 col-md-6">
                            <mat-form-field class="w-100">
                                <input type="text"
                                    (focusout)="documents.contractName = documents.contractName == undefined ? '' : (documents.contractName + '').trim()"
                                    matInput [placeholder]="'form.doc_name' | translate" name="contractName"
                                    [(ngModel)]="documents.contractName" maxlength="255" autocomplete="off">
                                <button mat-button *ngIf="documents.contractName" type="button" matSuffix
                                    mat-icon-button aria-label="Clear" (click)="documents.contractName=''">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>

                        <!-- Mẫu hợp đồng -->
                        <div class="col-lg-4 col-md-6">
                            <mat-form-field class="w-100">
                                <mat-label>{{'search_form.contract_template' | translate}}</mat-label>
                                <mat-select #templateSelect (focusout)="(checkFocus = true)"
                                    (selectionChange)="checkFocus = false"
                                    (focus)="commonService.openComboBox(checkFocus, templateSelect)" id="templateIds"
                                    name="templateIds" [(ngModel)]="documents.templateIds" [multiple]="true">
                                    <mat-option>
                                        <ngx-mat-select-search
                                            [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                                            [placeholderLabel]="'search_form.search' | translate"
                                            [formControl]="templateFilterCtrl">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option #allSelectedTemplate (click)="clickOptionTemplateAll()">
                                        {{ 'form.choose_all' | translate }}
                                    </mat-option>
                                    <mat-option *ngFor="let template of filteredTemplates | async"
                                        [value]="template.id" (click)="clickOptionTemplate()">
                                        {{ template.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                    </div>
                </form>
            </mat-expansion-panel>
        </mat-accordion>

        <!-- Group and sort -->
    </mat-card-content>

    <div class="row mt-3" style="margin-bottom: 15px;">
        <div class="col-lg-12 d-flex justify-content-center">
            <button mat-raised-button color="primary" type="submit" (click)="onExportReport()"
                [disabled]="!myForm.valid">
                <mat-icon class="mr-0" style="font-weight: 900;">receipt_long</mat-icon>
                {{'total_contract_report.title_btn' | translate}}
            </button>
        </div>
    </div>
</mat-card>
<app-history-report [mode]="mode" [formExport]="exportForm" (filterForm)="filterForm($event)"></app-history-report>
<ng4-loading-spinner *ngIf="showSpinner" [threshold]="1000" [timeout]="100000" [zIndex]="9999"></ng4-loading-spinner>
